<template>
    <div class="form-group_up">
        <label class="form-label" for="name-f">{{ __t('SEARCH') }}</label>
        <div class="input-group">
            <div class="input-group-prepend">
                <span class="input-group-text border-right-0">
                    <i class="fal fa-democrat"></i>
                </span>
            </div>

            <input
                type="text"
                v-model="search_txt"
                id="filter_search"
                class="form-control"
                :placeholder="__t('SEARCH')"
            />

            <div class="input-group-append srch">
                <button class="btn btn-primary shadow-0 waves-effect waves-themed" @click="send_search">
                    <i class="fal fa-search"></i>
                </button>

                <button
                    type="button"
                    class="btn btn-danger shadow-0 waves-effect waves-themed"
                    @click="clear_form"
                >
                    <span class="fal fa-times mr-1"></span>
                    {{ __t('CLEAN_FILTER') }}
                </button>
            </div>
        </div>
        <span class="help-block">{{ __t('SEARCH_HELPER') }}</span>
    </div>
</template>

<script>
export default {
    name: "filter_modificators",

    props: {
        searchValue: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            search_txt: this.searchValue
        };
    },

    methods: {
        send_search() {
            EventBus.$emit('search_modif_called', this.search_txt);
        },

        clear_form() {
            this.search_txt = '';
            EventBus.$emit('clean_modif_filter');
        }
    }
};
</script>

<style scoped>
</style>
